import React from "react";
import { Lightbulb } from "lucide-react";
import { ConfigSuggestion } from "../../../../../services/ai/types/ScanHistory.types";

interface ConfigSuggestionsProps {
  suggestions: ConfigSuggestion[];
}

const SuggestionItem = ({
  suggestion
}: {
  suggestion: ConfigSuggestion;
}): React.ReactElement => (
  <div className="rounded-md bg-card p-2.5">
    <p className="text-xs font-semibold text-foreground">
      {suggestion.description}
    </p>
    <p className="mt-1 text-xs text-muted-foreground">
      <span className="font-medium">Estimated impact:</span>{" "}
      {suggestion.estimatedImpact}
    </p>
    <p className="mt-1 text-xs text-muted-foreground">
      Go to Settings &rarr; {suggestion.settingsArea}
    </p>
  </div>
);

export const ConfigSuggestions = ({
  suggestions
}: ConfigSuggestionsProps): React.ReactElement | null => {
  if (suggestions.length === 0) {
    return null;
  }

  return (
    <section
      className="my-4 rounded-lg border border-[var(--borderColor,#e5e7eb)] p-3"
      aria-label="Configuration suggestions"
    >
      <div className="mb-2 flex items-center gap-2">
        <Lightbulb
          className="size-4 flex-shrink-0 text-[hsl(var(--warning))]"
          aria-hidden="true"
        />
        <h4 className="text-sm font-semibold text-[var(--primaryTextColor)]">
          Configuration Suggestions
        </h4>
      </div>
      <div className="space-y-2">
        {suggestions.map((suggestion, index) => (
          <SuggestionItem
            key={`${suggestion.settingsArea}-${index}`}
            suggestion={suggestion}
          />
        ))}
      </div>
    </section>
  );
};
